import React, { useState, useEffect, useContext, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Skeleton } from "antd";
import SearchBox from "../components/SearchBox";
import useControl from "../hooks/useControl";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import "./styles/scss/MemberGame.scss";
import {
	Request,
	catchErrorHandle,
	CTX_STATE,
	CTX_DISPATCH,
	creator,
	checkLogin,
	specialNavigate,
	sysMsg,
	countdown,
} from "../common";
import gameNone from "../styles/scss/img/common/game-none.png";

export default function App() {
	const location = useLocation();
	const navigate = useNavigate();
	const _state = useContext(CTX_STATE);
	const _dispatch = useContext(CTX_DISPATCH);
	const [hotNav, setHotNav] = useState("最近更新");
	const [keyWords, setKeyWords] = useState(location.state?.keyWords || "");
	const [hotList, setHotList] = useState(false); //可能会出现没有结果的情况，所以加载和为空要分开
	const [page, setPage] = useState(1);
	const [pageSize] = useState(20);
	const [total, setTotal] = useState(0);
	const [allTotal, setAllTotal] = useState(0);
	const { readyStart, stopGame, onProcessGame } = useControl();
	const searchBoxRef = useRef();

	const memberTime = _state.userInfo?.totalMinutes;

	const isOnlineGame = ({ product_name }) => {
		return (
			onProcessGame?.playParam?.[1] === product_name && onProcessGame?.isOnline
		);
	};

	const canFreePlay = ({ created_at }) => {
		return countdown(created_at) <= 0;
	};

	//网吧版兼容
	const isNetbar = window.mbQuery?.appInfo?.type === "netbar";

	useEffect(() => {
		if (!location.state?.keyWords) return;

		searchBoxRef.current.setValue(location.state?.keyWords);
	}, [location.state?.keyWords]);

	useEffect(() => {
		let data = {
			page,
			pageSize,
			filter: "group",
			sort: "source_price",
			define_price_sort: hotNav === "最近更新" ? "new" : "hot",
			scope: "vipselect",
		};

		keyWords &&
			(data = {
				...data,
				product_name: keyWords,
			});

		const req = new Request({
			url: "/api/getProductList",
			data,
		});

		const getData = async () => {
			try {
				const res = await req.send();

				if (res.status_code === 1000 && res.data?.data) {
					setHotList(res.data.data);
					setTotal(res.data.total);
					setAllTotal(res.data.total);
				}
			} catch (error) {
				console.log(catchErrorHandle(error));
			}
		};

		getData();

		return () => {
			req.cancel();
		};
	}, [hotNav, keyWords, page, pageSize]);

	const defaultConfig = (noPage) => {
		setHotList(false); //处理接口延迟列表显示错误问题
		!noPage && setPage(1);
	};

	const onChange = (current, pageSize) => {
		defaultConfig(true);
		setPage(current);
	};

	const searchBoxCallBack = (value) => {
		if (value !== keyWords) {
			defaultConfig();
		}

		setKeyWords(value);
	};

	return (
		<div className="main">
			<div className="member-game">
				<div className="head">
					<div className="left">
						大会员全部游戏列表（<span>{allTotal}</span>）
						<SearchBox
							ref={searchBoxRef}
							placeholder="请输入搜索的游戏"
							callback={searchBoxCallBack}
						/>
					</div>
					<div className="right">
						排序：
						{["最近更新", "最热"].map((ele, index) => {
							return (
								<React.Fragment key={index}>
									<button
										type="button"
										className={
											hotNav === ele.toLocaleLowerCase() ? "active" : ""
										}
										onClick={() => {
											if (ele.toLocaleLowerCase() !== hotNav) {
												defaultConfig();
											}

											setHotNav(ele.toLocaleLowerCase());
										}}
									>
										{ele}
									</button>
								</React.Fragment>
							);
						})}
					</div>
				</div>

				<div className="body">
					{Array.isArray(hotList) ? (
						hotList.length ? (
							<>
								<div className="content">
									{hotList.map((ele, index) => {
										return (
											<div className="list-item" key={index}>
												<div
													className="up"
													style={{
														backgroundImage: `url(${ele.list_img})`,
													}}
												>
													{!canFreePlay(ele) && (
														<div>{countdown(ele.created_at)}天后可玩</div>
													)}
												</div>
												<div className="down">{ele.product_name}</div>
												<div className="shadow">
													{canFreePlay(ele) &&
														(isNetbar || memberTime > 0 ? (
															isOnlineGame(ele) ? (
																<button
																	type="button"
																	className="stop-btn"
																	onClick={async () => {
																		try {
																			await stopGame();
																		} catch (error) {
																			sysMsg({
																				msg: "停止游戏失败",
																			});
																		}
																	}}
																>
																	停止游戏
																</button>
															) : (
																<button
																	type="button"
																	className="start-btn"
																	onClick={() => {
																		checkLogin(_state, _dispatch, () => {
																			const data = {
																				productId: ele.product_id
																			};

																			if (isNetbar) {
																				if(!_state.hasNetbarRight) {
																					sysMsg({
																						msg: "当前服务端不在线，请联系商家",
																					});
																
																					return;
																				}

																				data.isNetbarPlay = true;
																			} else {
																				data.isMemberPlay = true;
																			}

																			readyStart(data);
																		});
																	}}
																>
																	{isNetbar ? "本店免费玩" : "开始游戏"}
																</button>
															)
														) : (
															<button
																type="button"
																className="member-pay-btn"
																onClick={() => {
																	checkLogin(_state, _dispatch, () => {
																		_dispatch(
																			creator("setMemberPayIsShow", true)
																		);
																	});
																}}
															>
																开通
															</button>
														))}
													<button
														type="button"
														className="pay-btn"
														onClick={() => {
															specialNavigate(
																"/Goods",
																_state.token,
																navigate,
																false,
																ele
															);
														}}
													>
														单独购买
													</button>
												</div>
											</div>
										);
									})}
								</div>
								<Pagination
									showQuickJumper
									current={page}
									onChange={onChange}
									pageSize={pageSize}
									total={total}
									prevIcon="<"
									nextIcon=">"
								/>
							</>
						) : (
							<div className="none">
								<img src={gameNone} alt="none" />
								<p>当前暂无任何游戏...</p>
							</div>
						)
					) : (
						<div className="content">
							{[...new Array(20)].map((ele, index) => {
								return <Skeleton.Avatar key={index} active shape="square" />;
							})}
						</div>
					)}
				</div>
			</div>
		</div>
	);
}
